/* eslint-disable consistent-return */
import React from 'react'
import API from '../../services/API'
import Segment from '../../components/Segment'
import { Row, Divider, Col, Form, Typography, Button, Icon, Input, notification } from 'antd'
import { Link, useHistory } from 'react-router-dom'
import { currencyFormat, method } from '../../services/Utils'
import Search from '../../components/Search'
import moment from 'moment'

const current = JSON.parse(localStorage.getItem('sucursal'))

const { Paragraph } = Typography

const INIT = {
    payments: [],
    is_credit: false,
    abonados: 0,
    deudas: 0,
    grand_total: 0,
}

const ReportOrdersPaymentContainer = ({ user, match }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)

    const [cash, setCash] = React.useState(0)
    const [creditCard, setCreditCard] = React.useState(0)
    const [debitCard, setDebitCard] = React.useState(0)
    const [transfer, setTransfer] = React.useState({ amount: 0, reference: '' })

    const [subsidiary, setSubsidiary] = React.useState({
        id: current ? current.id : '',
        name: current ? current.name : '',
        utilesa: current ? current.logo : '',
    })

    const history = useHistory()

    const getPorAbonar = () => {
        const porAbonar = data.grand_total - data.abonados - cash - creditCard - debitCard

        return porAbonar
    }

    const getData = async () => {
        try {
            setloading(true)
            const response = await API.get(`/api/orders/${match.params.id}?with=user`)
            setData(response.data)
        } catch (error) {
            console.log(error)
        } finally {
            setloading(false)
        }
    }

    const getPaymentMethods = () => {
        const payments = { Transfer: transfer.amount, DebitCard: debitCard, CreditCard: creditCard, Cash: cash }
        const paymentMethods = Object.keys(payments).filter(method => payments[method] > 0)

        const translations = {
            Transfer: 'Transferencia',
            DebitCard: 'Tarjeta de Débito',
            CreditCard: 'Tarjeta de Crédito',
            Cash: 'Efectivo',
        }

        const translatedMethods = paymentMethods.map(method => translations[method])

        if (translatedMethods.length === 1) {
            return translatedMethods[0]
        }

        const lastMethod = translatedMethods.pop()
        const methodsString = translatedMethods.join(', ') + ' y ' + lastMethod

        return methodsString
    }

    function joinAnd(array) {
        if (array.length > 1) {
            return array.slice(0, -1).join(', ') + ' y ' + array.slice(-1)
        } else if (array.length === 1) {
            return array[0]
        } else {
            return 'El array está vacío'
        }
    }

    function extractPaymentMethods(data) {
        const methods = data.payments.map(item => item.payment_method)
        console.log('ss', methods)
        const uniqueMethods = [...new Set(methods)]

        const translationMap = {
            cash: 'Efectivo',
            debit_card: 'Tarjeta de Débito',
            credit_card: 'Tarjeta de Crédito',
            transfer: 'Transferencia',
        }

        return joinAnd(
            uniqueMethods
                .filter(method => ['cash', 'debit_card', 'credit_card', 'transfer'].includes(method))
                .map(method => translationMap[method])
        )
    }

    const getLastPayment = payments => {
        return payments
            .map(payment => ({ ...payment, created_at: moment(payment.created_at) }))
            .sort((a, b) => b.created_at - a.created_at)[0]
    }

    const getPaymentPDF = (type = 'comprobante') => {
        console.log('ss', type, data)
        setloading(true)

        const lastPayment = getLastPayment(data.payments)

        const lastPaymentDate = lastPayment ? moment(lastPayment.created_at).format('DD/MM/YYYY') : 'S/F'

        console.log(lastPaymentDate, 'payment')

        // check costumer name
        let costumerName = data.customer_first_name
            ? `${data.customer_first_name} ${data.customer_last_name}`
            : data.business_name || data.email

        let printData = {
            logo: 'logo.png',
            folio: data.unique_id,
            costumer_name: costumerName,
            cash_name: user.full_name,
            debt: type === 'comprobante' ? data.deudas : data.deudas - (creditCard + debitCard + cash + transfer.amount),
            abono: type === 'comprobante' ? data.abonados : data.abonados + creditCard + debitCard + cash + transfer.amount,
            saldo: data.grand_total,
            payment_method: type === 'comprobante' ? extractPaymentMethods(data) : getPaymentMethods(),
            last_payment_date: lastPaymentDate,
        }

        console.log(printData)

        API.post(`/api/paymentTicketWeb`, printData, { responseType: 'arraybuffer' })
            .then(response => {
                const file = new Blob([response.data], { type: 'application/pdf' })

                const fileURL = URL.createObjectURL(file)

                window.open(fileURL)
                setloading(false)
            })
            .catch(error => {
                console.log(error)
                setloading(false)
            })

        console.log('pdf', printData)
    }

    const savePayment = async () => {
        if (loading) {
            return
        }

        if (cash + creditCard + debitCard + transfer.amount + data.abonados > data.grand_total) {
            return notification.error({ message: 'La suma de los pagos supera el total del pedido' })
        }

        const order = data
        const toSend = []

        if (cash !== 0 && cash > 0) {
            toSend.push({
                order_id: order.id,
                payment_method: 'cash',
                amount: cash,
                payed_amount: cash,
                reference: null,
                user_id: user.id,
                subsidiary_id: subsidiary.id,
            })
        }

        if (creditCard !== 0 && creditCard > 0) {
            toSend.push({
                order_id: order.id,
                payment_method: 'credit_card',
                amount: creditCard,
                payed_amount: creditCard,
                reference: null,
                user_id: user.id,
                subsidiary_id: subsidiary.id,
            })
        }

        if (debitCard !== 0 && debitCard > 0) {
            toSend.push({
                order_id: order.id,
                payment_method: 'debit_card',
                amount: debitCard,
                payed_amount: debitCard,
                reference: null,
                user_id: user.id,
                subsidiary_id: subsidiary.id,
            })
        }

        if (transfer.amount !== 0 && transfer.amount > 0) {
            if (!transfer.reference) {
                return notification.error({ message: 'Transferencia no tiene referencia' })
            }

            toSend.push({
                order_id: order.id,
                payment_method: 'transfer',
                amount: transfer.amount,
                payed_amount: transfer.amount,
                reference: transfer.reference,
                user_id: user.id,
                subsidiary_id: subsidiary.id,
            })
        }

        try {
            setloading(true)

            const response = await API.post(`/api/orders/${order.id}/pay`, { payments: toSend }).then(async _ => {
                await getPaymentPDF('payment')
            })
            notification.success({ message: 'Pagos guardados con éxito' })
            history.push(data.is_credit ? '/report/credit' : '/report/sales')
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                console.log('error.response.data: ', error.response.data.message)
                notification.error({
                    message: error.response.data.message,
                })
            } else {
                console.log('general error: ', error)
                notification.error({
                    message: `Error general: ${error}`,
                })
            }
        } finally {
            setloading(false)
        }
    }

    React.useEffect(() => {
        getData()
    }, [])

    return (
        <Segment loading={loading}>
            <Divider>Pago de credito</Divider>
            <Form style={{ maxWidth: '500px', margin: 'auto' }} className="form-border">
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>ID único:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>{data.unique_id}</Paragraph>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Cliente:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph>
                            {`${data.customer_first_name} ${data.customer_last_name} (${data.customer_email})`}{' '}
                        </Paragraph>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Total:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {Intl.NumberFormat('es-MX', {
                            style: 'currency',
                            currency: 'MXN',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 8,
                        }).format(data.grand_total)}
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Abonado:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {Intl.NumberFormat('es-MX', {
                            style: 'currency',
                            currency: 'MXN',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 8,
                        }).format(data.abonados)}
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Por abonar:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {Intl.NumberFormat('es-MX', {
                            style: 'currency',
                            currency: 'MXN',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 8,
                        }).format(getPorAbonar())}
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Deuda:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        {Intl.NumberFormat('es-MX', {
                            style: 'currency',
                            currency: 'MXN',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 8,
                        }).format(data.deudas)}
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Sucursal:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item>
                            <Search
                                value={subsidiary.name}
                                placeholder="Sucursal"
                                onSearch={value => `/api/subsidiaries?filter[active]&filter[name]=${value}`}
                                onChange={(key, value) => {
                                    setSubsidiary(value)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Efectivo:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item>
                            <Input
                                prefix={<Icon type="dollar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="Efectivo"
                                onChange={e => {
                                    setCash(isNaN(e.target.value) ? 0 : +e.target.value)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>T.crédito:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item>
                            <Input
                                placeholder="T.crédito"
                                prefix={<Icon type="credit-card" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                onChange={e => {
                                    setCreditCard(isNaN(e.target.value) ? 0 : +e.target.value)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>T.débito:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item>
                            <Input
                                placeholder="T.débito"
                                prefix={<Icon type="credit-card" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                onChange={e => {
                                    setDebitCard(Number.isNaN(e.target.value) ? 0 : +e.target.value)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Paragraph strong>Transferencia:</Paragraph>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item>
                            <Input
                                placeholder="Cantidad"
                                prefix={<Icon type="credit-card" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                onChange={e => {
                                    setTransfer({
                                        ...transfer,
                                        amount: Number.isNaN(e.target.value) ? 0 : +e.target.value,
                                    })
                                }}
                            />
                            <Input
                                placeholder="Referencia"
                                onChange={e => {
                                    setTransfer({ ...transfer, reference: e.target.value })
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Row type="flex" justify="center" style={{ marginTop: '50px' }}>
                <Form.Item>
                    <Link to={data.is_credit ? '/report/credit' : '/report/sales'} style={{ marginLeft: '5px' }}>
                        <Button icon="arrow-left">Regresar</Button>
                    </Link>
                    <Divider type="vertical" />
                    <Button
                        icon="dollar"
                        onClick={_ => {
                            getPaymentPDF()
                        }}
                    >
                        Comprobante de abonado
                    </Button>
                    <Divider type="vertical" />
                    <Button
                        icon="dollar"
                        onClick={savePayment}
                        disabled={
                            data.is_payed ||
                            (debitCard === 0 && creditCard === 0 && cash === 0 && transfer.amount === 0)
                        }
                    >
                        Pagar
                    </Button>
                </Form.Item>
            </Row>
        </Segment>
    )
}

export default ReportOrdersPaymentContainer
